<div class="inventory-modal">
  <div class="inventory-modal__header">
    <!--Edit Serial Number-->

    <div class="text-block">

      <span class="inventory-modal__title">{{'Details' | translate | async}}</span>
      <span class="inventory-modal__title" style="padding-left: 10px;" *ngIf="editableSerialNo">{{system.SerialNumber}}
      </span>
      <span *ngIf="!editableSerialNo" class="text-block__important">
        <span>
          <input class="input-container__input" #dataInput [value]="system.SerialNumber" [(ngModel)]="serialNumber"
            focusOnShow />
        </span>

        <i class="material-icons save-button__icon editSave" matTooltip="Save"
          (click)="onSaveSerialNumber(system)">check</i>
        <i class="material-icons cancel-button__icon editcancel" matTooltip="Cancel"
          (click)="onCancelSerialNumber(1)">close</i>
      </span>
      <span *ngIf="editableSerialNo">
        <i class="material-icons text-container__edit inventory-modal__title" style="cursor: pointer;"
          (click)="editSerialNumber(system)" matTooltip="Click to edit Serial number"
          *ngIf="luUCInventoryStatusModel != 7">edit</i>


      </span>

    </div>
    <!--test code-->
    <!--Chage Side-->

    <div class="panel__header__title serialnumber framecondition divflex" *ngIf="system.SystemType==2">
      <span style="width: 130px;">{{'Frame Condition' | translate | async}}</span>
      <select class="frameconditionoptions" [ngModel]="system.SystemCondition"
        [ngStyle]="{ 'background-color': system.SystemConditionColor }"
        (change)="updateSystemCondition(system, $event.target.value)"
        [title]="luUCInventoryStatusModel !== 6 && isAdministrator ? 'Click to edit condition' : ''">
        <option value="A" class="frameconditionoptionscolorA">A</option>
        <option value="B" class="frameconditionoptionscolorB">B</option>
        <option value="C" class="frameconditionoptionscolorC">C</option>
        <option value="X" class="frameconditionoptionscolorX">X</option>
      </select>
    </div>

    <span *ngIf="flagSideDropDown">
      <mat-form-field class="setup-form-full-width">
        <mat-select [(ngModel)]="inventorySide" matTooltip="Click to Edit"
          (selectionChange)="changeSideInventory($event)" [(value)]="selectedSide" name="statusSide"
          placeholder="{{'Select Side' | translate | async}}" [disabled]="luUCInventoryStatusModel == 7">

          <mat-option [value]="1">Left</mat-option>
          <mat-option [value]="2">Right</mat-option>

        </mat-select>
      </mat-form-field>
    </span>

    <div class="panel__content">
      <div class="columnsheadersmgr" *ngIf="isBasicUser == 1">
        <mat-checkbox
          [(ngModel)]="editComponent"
          *ngIf="isAdministrator"
          class="margin"
          [disabled]="luUCInventoryStatusModel === 6"
          [matTooltip]="luUCInventoryStatusModel === 6
            ? 'Component editing is disabled while the system is attached to equipment.'
            : ''">
          <span class="example-margin">
            {{ "Edit Component" | translate | async }}
          </span>
        </mat-checkbox>
      </div>
    </div>
    <!--Chage Side-->
    <!-- <span class="inventory-modal__title">{{'Details' | translate | async}} {{system.SerialNumber}}</span> -->
    <span>
      <mat-form-field class="setup-form-full-width">
        <mat-select [(ngModel)]="luUCInventoryStatusModel" (selectionChange)="changeluUCInventoryStatusModel($event)"
          [(value)]="selectedType" name="status" placeholder="{{'Select Status' | translate | async}}"
          [disabled]="luUCInventoryStatusModel == 7">
          <mat-option [disabled]="luUCInventoryStatusModel == 6">None</mat-option>
          <mat-option *ngFor="let item of _dropDownLists.luUCIInventoryStatusModel" [value]="item.Id"
            [disabled]="checkInventoryStatus(item.Id)">
            {{ item.Title }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>

    <i class="material-icons inventory-modal__close-button" (click)="onNoClickPopup()"
      matTooltip="Close Popup">close</i>

  </div>
  <div class="row">
  </div>
  <div class="inventory-modal__body">
    <div *ngIf="luUCInventoryStatusModel == 7">
      <p *ngIf="system.SystemType==2" style="color: red;">This frame is undergoing repair in WSRE. Please make any
        changes through WSRE.Once the repair is complete, you will be able to adjust in inventory again. </p>
      <p *ngIf="system.SystemType==1" style="color: red;">This chain is undergoing repair in WSRE. Please make any
        changes through WSRE.Once the repair is complete, you will be able to adjust in inventory again.</p>

    </div>
    <div class="column-container flex-grow" *ngIf="system.SystemType == 2">
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Budget Life' | translate | async }}
          </span>
          <span class="text-block__important">
            <span *ngIf="!editableSystemBudgetLife">
              {{system.BudgetLife}} hrs
              <i *ngIf="luUCInventoryStatusModel != 6 && isAdministrator" class="material-icons text-container__edit"
                style="cursor: pointer; font-size :16px;" title="Edit Budget Life"
                (click)="editSysBudgetLife(system.SystemId)">edit</i>
            </span>
            <span *ngIf="editableSystemBudgetLife" class="text-block__important divflex">
              <span>
                <input #dataInput [id]="'dataInputBudgetLife_' + system.SystemId" [value]="system.BudgetLife"
                  [(ngModel)]="system.BudgetLife" focusOnShow />
              </span>
              <span>
                <i class="material-icons save-button__icon editcancel" title="Save Changes"
                  (click)="onSaveSysBudgetLife(system.SystemId,system.BudgetLife)">check</i>
              </span>
              <span>
                <i class="material-icons cancel-button__icon editcancel" title="Cancel Changes"
                  (click)="onCancelSysBudgetLife()">close</i>
              </span>
            </span>
          </span>
        </div>
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Distance Budget' | translate | async }}
          </span>
          <span class="text-block__important">
            <span *ngIf="!editableSysBudgetDistance">
              {{system.BudgetDistance}} km
              <i *ngIf="luUCInventoryStatusModel != 6 && isAdministrator" class="material-icons text-container__edit"
                style="cursor: pointer; font-size :16px;" title="Edit Distance Budget"
                (click)="editSysBudgetDistance(system.SystemId)">edit</i>
            </span>
            <span *ngIf="editableSysBudgetDistance" class="text-block__important divflex">
              <span>
                <input #dataInput [id]="'dataInputBudgetDistance_' + system.SystemId" [value]="system.BudgetDistance"
                  [(ngModel)]="system.BudgetDistance" focusOnShow />
              </span>

              <i class="material-icons save-button__icon editcancel" title="Save Changes"
                (click)="onSaveSysBudgetDistance(system.SystemId,system.BudgetDistance)">check</i>
              <i class="material-icons cancel-button__icon editcancel" title="Cancel Changes"
                (click)="onCancelSysBudgetDistance()">close</i>
            </span>
          </span>
        </div>
      </div>
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Life Lived' | translate | async }}
          </span>
          <span class="text-block__important">
            {{system.LifeLived}} hrs
          </span>
        </div>
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Life Lived' | translate | async }}
          </span>
          <span class="text-block__important">
            {{system.LifeLivedKm}} km
          </span>
        </div>
      </div>
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Residual Life' | translate | async }}
          </span>
          <span class="text-block__important">
            {{system.BudgetLife > 0 ? system.BudgetLife - system.LifeLived : 0}} hrs
          </span>
        </div>
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Residual Life' | translate | async }}
          </span>
          <span class="text-block__important">
            {{system.BudgetDistance > 0 ? system.BudgetDistance - system.LifeLivedKm : 0}} km
          </span>
        </div>
      </div>
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Frame Cost' | translate | async }}
          </span>
          <span class="text-block__important">
            <span *ngIf="!editableFrameCost">
              ${{FrameCost}}
              <i *ngIf="luUCInventoryStatusModel != 6 && isAdministrator" class="material-icons text-container__edit"
                style="cursor: pointer; font-size :16px;" title="Edit Frame Cost Budget"
                (click)="editSysFrameCost(system.SystemId)">edit</i>
            </span>
            <span *ngIf="editableFrameCost" class="text-block__important divflex">
              <span>
                <input #dataInput [id]="'dataInputBudgetDistance_' + system.SystemId" [value]="FrameCost"
                  [(ngModel)]="FrameCost" focusOnShow />
              </span>

              <i class="material-icons save-button__icon editcancel" title="Save Changes"
                (click)="onSaveSystemFrameCost(system.SystemId,FrameCost)">check</i>
              <i class="material-icons cancel-button__icon editcancel" title="Cancel Changes"
                (click)="onCancelFrameCost()">close</i>
            </span>
          </span>
        </div>
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Frame Repair Cost' | translate | async }}
          </span>
          <span class="text-block__important">
            <span *ngIf="!editableFrameRepairCost">
              ${{FrameRepairCost}}
              <i *ngIf="luUCInventoryStatusModel != 6 && isAdministrator" class="material-icons text-container__edit"
                style="cursor: pointer; font-size :16px;" title="Edit Frame Cost Budget"
                (click)="editSysFrameRepairCost(system.SystemId)">edit</i>
            </span>
            <span *ngIf="editableFrameRepairCost" class="text-block__important divflex">
              <span>
                <input #dataInput [id]="'dataInputBudgetDistance_' + system.SystemId" [value]="FrameRepairCost"
                  [(ngModel)]="FrameRepairCost" focusOnShow />
              </span>

              <i class="material-icons save-button__icon editcancel" title="Save Changes"
                (click)="onSaveSystemFrameRepairCost(system.SystemId,FrameRepairCost)">check</i>
              <i class="material-icons cancel-button__icon editcancel" title="Cancel Changes"
                (click)="onCancelFrameRepairCost()">close</i>
            </span>
          </span>
        </div>
      </div>
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            Initial Rolling Stock Cost
          </span>
          <span class="text-block__important">
            ${{TotalInitalCost}}.00
          </span>
        </div>
        <div class="text-block">
          <span class="text-block__label">
            Rolling Track Repair Cost
          </span>
          <span class="text-block__important">
            ${{TotalRepairCost}}.00
          </span>
        </div>
      </div>
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Total Purchase Cost (inc. Current Components)' | translate | async }}
          </span>
          <span class="text-block__important">
            ${{system.TotalComponentPurchaseCost}}.00
          </span>
        </div>
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Total Component Repairs Cost (inc. All Components Ever)' | translate | async }}
          </span>
          <span class="text-block__important">
            ${{system.TotalComponentRepairsCost}}.00
          </span>
        </div>
      </div>
      <div class="column-container__column">
        <!--*ngIf="(equipmentDetails.FamilyId!=177 && equipmentDetails.FamilyId!=203)"-->
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Frame Configuration' | translate | async }}
          </span>
          <span class="text-block__important">
            <ng-container *ngIf="system.ToeOutFrame == 0">
              Unknown
            </ng-container>
            <ng-container *ngIf="system.ToeOutFrame == 1">
              {{ 'Toe Out' | translate | async }}
            </ng-container>
            <ng-container *ngIf="system.ToeOutFrame == 2">
              {{ 'Straight' | translate | async }}
            </ng-container>
            <ng-container *ngIf="luUCInventoryStatusModel != 6 && isAdministrator">
              <a (click)="openTrackCofiguration(1, system.ToeOutFrame, system.SystemId, system.Side)">
                <i class="material-icons " style="color: black; font-size: 16px; cursor: pointer;">create</i>
              </a>
            </ng-container>
          </span>
        </div>
        <div class="text-block" *ngIf="!showradio">
          <span class="text-block__label">
            {{ 'Cannon Type' | translate | async }}
          </span>
          <span class="text-block__important">
            <ng-container *ngIf="system.CastFrame == 0">
              Unknown
            </ng-container>
            <ng-container *ngIf="system.CastFrame == 1">
              {{ 'Cast' | translate | async }}
            </ng-container>
            <ng-container *ngIf="system.CastFrame == 2">
              {{ 'Fabricated' | translate | async }}
            </ng-container>
            <ng-container *ngIf="luUCInventoryStatusModel != 6 && isAdministrator">
              <a (click)="openTrackCofiguration(2, system.CastFrame, system.SystemId, system.Side)">
                <i class="material-icons " style="color: black; font-size: 16px; cursor: pointer;">create</i>
              </a>
            </ng-container>
          </span>
        </div>
      </div>
    </div>
    <div class="center" *ngIf="isLoading">
      <mat-spinner></mat-spinner>
    </div>
    <div [hidden]="isLoading">
      <mat-tab-group [(selectedIndex)]="selectedTab" (selectedTabChange)="onTabChange($event)">
        <mat-tab [label]="'Components' | translate | async">
          <div *ngIf="selectedTab == 0">
            <div class="tab-content" style="height: calc(100vh - 460px);">
              <table class="table table--full-width table--striped">
                <thead>
                  <tr>
                    <th class="width-max">{{'Component' | translate | async}}</th>
                    <th>{{'Position' | translate | async}}</th>
                    <!-- <th>{{'Part Number' | translate | async}}</th> -->
                    <th>{{'Make' | translate | async}}</th>
                    <th>{{'CMU (hrs)' | translate | async}}</th>
                    <th>{{'DOC (Km)' | translate | async}}</th>
                    <th>{{'Measurement' | translate | async}}</th>
                    <th>{{'Tool' | translate | async}}</th>
                    <th>{{'%Worn' | translate | async}}</th>
                    <th>{{'Condition' | translate | async}}</th>
                    <th>{{'Budget' | translate | async}}</th>
                    <th>{{'Dist. Budget (Km)' | translate | async}}</th>
                    <th *ngIf="SystemTypeName == 'Chain' || SystemTypeName == 'Frame'">{{'Comment' | translate | async}}
                    </th>
                    <th *ngIf="SystemTypeName == 'Chain' || SystemTypeName == 'Frame'">{{'Images' | translate | async}}
                    </th>
                    <th>{{'Latest Action' | translate | async}}</th>
                    <th>{{'Latest Action Date' | translate | async}}</th>
                    <th>{{'Initial Cost' | translate | async}}</th>
                    <th>{{'Repair Cost' | translate | async}}</th>
                    <th *ngIf="luUCInventoryStatusModel != 7">{{'Record Action' | translate | async}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="table-row-style" *ngFor="let component of componentList">
                    <td>{{component.Name}}
                      <span *ngIf="editComponent">
                        <i
                          class="material-icons text-container__edit"
                          style="cursor: pointer; font-size: 16px;"
                          title="Click to edit Component"
                          (click)="openEditComponentPopup(component)">
                          edit
                        </i>
                      </span>
                    </td>
                    <td> {{showPosition(component.Pos,component.CompartTypeId)}}</td>
                    <td>{{component.Brand}}</td>
                    <td>
                      <div>
                        <click-to-edit [editable]="!isRopeShovel() && luUCInventoryStatusModel !== 6"
                          [data]="component.CMU" (dataChanged)="CMUChanged($event, component)" [alignRight]="true"
                          [LuStatusID]="luUCInventoryStatusModel">
                        </click-to-edit>
                      </div>
                    </td>
                    <td>
                      <div>
                        <click-to-edit [editable]="!isRopeShovel()" [data]="component.DOC"
                          (dataChanged)="DOCChanged($event, component)" [alignRight]="true"
                          [LuStatusID]="luUCInventoryStatusModel">
                        </click-to-edit>
                      </div>
                    </td>
                    <td>
                      <div
                        *ngIf="component.ToolId !== toolType.Eval && component.ToolId !== toolType.YESorNO && component.ToolId !== toolType.PassorFail">
                        <click-to-edit [editable]="!isRopeShovel()" [data]="component.MeasurementPoints"
                          (dataChanged)="measurementChanged($event, component)" [alignRight]="true"
                          [LuStatusID]="luUCInventoryStatusModel">
                        </click-to-edit>
                      </div>
                      <div *ngIf="component.ToolId === toolType.Eval">
                        <span *ngIf="luUCInventoryStatusModel != 7" [alignRight]="true" [matMenuTriggerFor]="evalMenu"
                          class="tool-button"
                          title="{{'Change Eval' | translate | async}}">{{component.Condition}}</span>
                        <span *ngIf="luUCInventoryStatusModel == 7">{{component.Condition}}</span>
                        <mat-menu #evalMenu="matMenu">
                          <button mat-menu-item (click)="changeEval('A',component)">{{'A'}}</button>
                          <button mat-menu-item (click)="changeEval('B',component)">{{'B'}}</button>
                          <button mat-menu-item (click)="changeEval('C',component)">{{'C'}}</button>
                          <button mat-menu-item (click)="changeEval('X',component)">{{'X'}}</button>
                        </mat-menu>
                      </div>
                      <div *ngIf='component.ToolId === toolType.YESorNO'>
                        <span *ngIf="luUCInventoryStatusModel != 7" [alignRight]="true" [matMenuTriggerFor]="yesNoMenu"
                          class="tool-button" title="{{ 'Change Component Yes/No' | translate | async }}">
                          {{component.MeasurementPoints === 1 ? ('Yes' | translate | async) :
                          component.MeasurementPoints === 0 ? ('No' | translate | async) : ''}}
                        </span>
                        <span *ngIf="luUCInventoryStatusModel == 7">
                          {{component.MeasurementPoints === 1 ? ('Yes' | translate | async) :
                          component.MeasurementPoints === 0 ? ('No' | translate | async) : ''}}
                        </span>
                        <mat-menu #yesNoMenu="matMenu">
                          <button mat-menu-item (click)="onToolOptionSelect(component, toolYesNo.Yes)">{{ 'Yes' |
                            translate | async }}</button>
                          <button mat-menu-item (click)="onToolOptionSelect(component, toolYesNo.No)">{{ 'No' |
                            translate | async }}</button>
                        </mat-menu>
                      </div>
                      <div *ngIf='component.ToolId === toolType.PassorFail'>
                        <span *ngIf="luUCInventoryStatusModel != 7" [alignRight]="true"
                          [matMenuTriggerFor]="passFailMenu" class="tool-button"
                          title="{{ 'Change Component Pass/Fail' | translate | async }}">
                          {{ component.MeasurementPoints === 1 ? ('Pass' | translate | async) :
                          component.MeasurementPoints === 0 ? ('Fail' | translate | async) :''
                          }}
                        </span>
                        <span *ngIf="luUCInventoryStatusModel == 7">
                          {{ component.MeasurementPoints === 1 ? ('Pass' | translate | async) :
                          component.MeasurementPoints === 0 ? ('Fail' | translate | async) :''
                          }}
                        </span>
                        <mat-menu #passFailMenu="matMenu">
                          <button mat-menu-item (click)="onToolOptionSelect(component, toolPassFail.Pass)">{{ 'Pass' |
                            translate | async }}</button>
                          <button mat-menu-item (click)="onToolOptionSelect(component, toolPassFail.Fail)">{{ 'Fail' |
                            translate | async }}</button>
                        </mat-menu>
                      </div>
                    </td>
                    <td>

                      <div matToolip="Change measurement tool" [matMenuTriggerFor]="changeToolMenu"
                        class="text-container" *ngIf="luUCInventoryStatusModel != 7">
                        <span class="text-container__text" class="tool-button">
                          {{component.ToolName}}
                        </span>
                      </div>
                      <div *ngIf="luUCInventoryStatusModel == 7">
                        {{component.ToolName}}
                      </div>
                      <mat-menu #changeToolMenu="matMenu">
                        <button mat-menu-item *ngFor="let tool of component.PossibleTools"
                          (click)="changeTool(tool, component)">
                          {{tool.ToolName}}
                        </button>
                      </mat-menu>
                    </td>
                    <td>
                      {{component.WornPercentage.toFixed(1)}}
                    </td>
                    <td *ngIf="luUCInventoryStatusModel != 7">
                      <div matToolip="Change Overall Eval" [matMenuTriggerFor]="changeEvalMenu" class="condition">
                        <span class="text-container__text"> {{component.Condition}} </span>
                        <i class="material-icons condition__edit">edit</i>
                      </div>

                      <mat-menu #changeEvalMenu="matMenu">
                        <button mat-menu-item (click)="changeEval('A', component)">A</button>
                        <button mat-menu-item (click)="changeEval('B', component)">B</button>
                        <button mat-menu-item (click)="changeEval('C', component)">C</button>
                        <button mat-menu-item (click)="changeEval('X', component)">X</button>
                      </mat-menu>
                    </td>
                    <td *ngIf="luUCInventoryStatusModel == 7">
                      <div matToolip="Change Overall Eval" class="condition">
                        <span class="text-container__text"> {{component.Condition}} </span>
                      </div>
                    </td>
                    <td>
                      <div>
                        <click-to-edit [editable]="!isRopeShovel()" [data]="component.Budget"
                          (dataChanged)="BudgetChanged($event, component)" [alignRight]="true"
                          [LuStatusID]="luUCInventoryStatusModel">
                        </click-to-edit>
                      </div>
                    </td>
                    <td>
                      <div>
                        <click-to-edit [editable]="!isRopeShovel()" [data]="component.DistanceBudget"
                          (dataChanged)="DistanceBudgetChanged($event, component)" [alignRight]="true"
                          [LuStatusID]="luUCInventoryStatusModel">
                        </click-to-edit>
                      </div>
                    </td>
                    <td *ngIf="SystemTypeName == 'Chain' || SystemTypeName == 'Frame'">
                      <div class="add-recommendation" id="component.CompartId"
                        [class.has-recommendation]="component.Comment !=='' && component.Comment!== null"
                        *ngIf="luUCInventoryStatusModel!=7">
                        <i title="{{getCommentTitle(component.Comment)}}" class="material-icons"
                          (click)="AddComment(component)">message</i>
                      </div>

                      <div class="add-recommendation" id="component.CompartId"
                        [class.has-recommendation]="component.Comment !=='' && component.Comment!== null"
                        *ngIf="luUCInventoryStatusModel==7">
                        <i title="{{getCommentTitle(component.Comment)}}" class="material-icons">message</i>
                      </div>
                    </td>

                    <td *ngIf="SystemTypeName == 'Chain' || SystemTypeName == 'Frame'">
                      <div *ngIf="luUCInventoryStatusModel!=7">
                        <upload-photo *ngIf="component.ImagesCount == null || component.ImagesCount == 0"
                          (onPhotoUpload)="loadPhoto(component)" [componentModel]="component"
                          [comingFrom]="imagesComingFrom"
                          [referenceTableId]="component.ComponentInInventoryDetailId"></upload-photo>
                        <i *ngIf="component.ImagesCount != null && component.ImagesCount > 0"
                          class="material-icons upload-container__icon"
                          style="border: 1px solid #ed5565;color: #ed5565; padding: 8px;"
                          (click)="viewComponentPhoto(component)">
                          add_a_photo
                        </i>
                      </div>
                      <div *ngIf="luUCInventoryStatusModel==7">

                        <i class="material-icons upload-container__icon"
                          style="border: 1px solid #f1e3e5;color: #f1e3e5; padding: 8px;">
                          add_a_photo
                        </i>
                      </div>

                    </td>

                    <td>
                      {{component.LastestActionName}}
                    </td>
                    <td>
                      {{component.LastestActionDate}}
                    </td>
                    <td>
                      <span style="display: flex;">
                        {{component.InititalCost | currency }}
                        <i class="material-icons text-container__edit class-pointer"
                          (click)="costAction(component)">edit</i>
                      </span>

                    </td>
                    <td>
                      <span style="display: flex;"> {{component.TotalCost | currency }}
                      </span>

                    </td>

                    <td *ngIf="luUCInventoryStatusModel != 7">
                      <i *ngIf="!component.IsChild" class="material-icons text-container__edit class-pointer"
                        (click)="recordAction(component)">edit</i>

                    </td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </mat-tab>
        <mat-tab [label]="'History' | translate | async">
          <div *ngIf="selectedTab == 1 && systemId" style="height: calc(100dvh - 500px);">
            <app-audit-trail [systemIdLeft]="systemId" [screenId]="screenId" [moduleId]="3" [isInventory]="true" [itemsPerPage]="100"></app-audit-trail>
          </div>
        </mat-tab>
        <mat-tab [label]="'Notes' | translate | async">
          <div style="margin: 16px 0;" *ngIf="selectedTab == 2">
            <mat-form-field style="width:100%">
              <textarea matInput placeholder=" {{'System Notes' | translate | async}}"
                [(ngModel)]="system.SystemNote"></textarea>
            </mat-form-field>
          </div>
          <div class="inventory-modal__footer" *ngIf="luUCInventoryStatusModel != 7">
            <button mat-raised-button (click)="onNoClick()">{{'Cancel' | translate | async}}</button>
            <button mat-raised-button color="warn" [class.loading]="saving" (click)="saveNote()">
              <span class="material-icons button__icon">check</span>
              <span class="button__text">{{'Update Notes' | translate | async}}</span>
            </button>
          </div>
        </mat-tab>
        <mat-tab [label]="'Relocate System' | translate | async">
          <div style="margin: 16px 0;" *ngIf="selectedTab == 3">
            <mat-form-field class="setup-form-full-width">
              <mat-select (selectionChange)="customerChanged($event)" name="Relocate To Customer"
                [(ngModel)]="selectedCustomer"
                [disabled]="luUCInventoryStatusModel == 7 || luUCInventoryStatusModel == 6"
                placeholder="{{'Relocate To Customer' | translate | async}}" required>
                <mat-option *ngFor="let customer of customerList" [value]="customer">
                  {{ customer.Title }}
                </mat-option>
              </mat-select>

            </mat-form-field>
            <mat-form-field class="setup-form-full-width">
              <mat-select (selectionChange)="jobsiteChanged($event)" name="Relocate To Jobsite"
                [(ngModel)]="selectedJobsite"
                [disabled]="luUCInventoryStatusModel == 7 || luUCInventoryStatusModel == 6"
                placeholder="{{'Relocate To Jobsite' | translate | async}}" required>

                <mat-option *ngFor="let jobsite of availableJobsites" [value]="jobsite">
                  {{ jobsite.Title }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="!jobsiteSelected()">Please choose a jobsite</mat-error>
            </mat-form-field>
          </div>
          <div class="inventory-modal__footer" *ngIf="luUCInventoryStatusModel != 7 || luUCInventoryStatusModel != 6">
            <button mat-raised-button (click)="onNoClick()">{{'Cancel' | translate | async}}</button>
            <button mat-raised-button color="warn" [class.loading]="saving" [disabled]="!jobsiteSelected()"
              (click)="reloacateSystem()">
              <span class="material-icons button__icon">check</span>
              <span class="button__text">{{'Relocate System' | translate | async}}</span>
            </button>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>

</div>
